var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "custom-dialog-action-buttons-container" },
    [
      _vm.showSecondaryButton
        ? _c("LfLabelButtonComponent", {
            attrs: {
              text: _vm.secondaryButtonTextRendered,
              action: () => _vm.closeCustomDialog(),
              variant: _vm.variant.outlined,
            },
          })
        : _vm._e(),
      _vm.mainAction
        ? _c("LfLabelButtonComponent", {
            attrs: {
              text: _vm.primaryButtonTextRendered,
              action: () => _vm.onMainBtnClicked(),
              disabled: _vm.disabledButtons,
              variant: _vm.variant.solid,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }